/**
 * President Send / Unshare for a planting plan.
 * Ground club picker still uses allow_area_calculations; Send does not.
 */

export const SHARE_EMPTY =
  'You need to be president of a club to send a plan.';
export const SHARE_LEDE =
  'Members get a read-only copy in Feed & Seed. You can still edit it.';
export const SHARE_LOAD_ERROR = 'Could not load your clubs.';
export const SHARE_SEND_ERROR = 'Could not send this plan.';
export const SHARE_UNSHARE_ERROR = 'Could not unshare this plan.';
export const SHARE_WRONG_CLUB =
  'This plan uses fields from another club.';
export const SHARE_LINE_NONE = 'Not shared with anybody yet.';
export const SHARE_LINE_FALLBACK = 'Shared with a club';

export function presidentShareClubs(clubs) {
  return (Array.isArray(clubs) ? clubs : []).filter((club) => club.is_president === true);
}

export function clubNameMap(clubs) {
  const names = {};
  (Array.isArray(clubs) ? clubs : []).forEach((club) => {
    if (club?.id == null) return;
    names[club.id] = club.name || '';
  });
  return names;
}

export function planGroundClubId(group) {
  const id = group?.club;
  return typeof id === 'number' && Number.isFinite(id) ? id : null;
}

export function canSendPlanToClub(group, clubId) {
  const groundId = planGroundClubId(group);
  return groundId == null || groundId === clubId;
}

export function planSharedClubId(group) {
  const id = group?.shared_with_club;
  return typeof id === 'number' && Number.isFinite(id) ? id : null;
}

export function isPlanSharedWithClub(group, clubId) {
  return planSharedClubId(group) === clubId;
}

export function shareSentToast(clubName) {
  const name = String(clubName || '').trim().toUpperCase() || 'CLUB';
  return `SENT · ${name}`;
}

export function shareUnsharedToast(clubName) {
  const name = String(clubName || '').trim().toUpperCase() || 'CLUB';
  return `UNSHARED · ${name}`;
}

export function shareClubCta(shared) {
  return shared ? 'UNSHARE' : 'SEND';
}

export function planShareLine(group, clubNames = {}) {
  const clubId = planSharedClubId(group);
  if (clubId == null) return SHARE_LINE_NONE;
  const name = clubNames[clubId] || clubNames[String(clubId)];
  return name ? `Shared with ${name}` : SHARE_LINE_FALLBACK;
}

export function formatShareApiError(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  return fallback;
}
